(() => {
  function mount(root = document) {
    root.querySelectorAll('[data-tac-real-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryMounted) return;
      gallery.dataset.galleryMounted = 'true';
      const track = gallery.querySelector('.tac-real-gallery__track');
      const buttons = [...gallery.querySelectorAll('[data-real-gallery-direction]')];
      const update = () => {
        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        const distance = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
        track.scrollBy({ left: Number(button.dataset.realGalleryDirection) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', update, { passive: true });
      gallery.querySelector('[data-real-gallery-controls]').hidden = false;
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  }
  mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
